<template>
  	<div id="coinDetail">
  		<mt-header fixed :title="$t(title)">
          	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
          	<!-- <mt-button slot="right" @click="addAddress()">
          		<img src="../../assets/img/coinDetail/ico_fenxiang_shoukuan.png" alt="" class="add">
          	</mt-button> -->
        	<!-- <mt-button slot="right" class="join" @click="doshare()"><img src="@/assets/img/coinDetail/ico_fenxiang_shoukuan.png" alt="" style="width: 20px;"></mt-button> -->
        </mt-header>
        <div class="content">
        	<p class="time wx_fontSize2">{{$t('交易时间')}} {{this.$route.query.log_time | parseTime}}</p>
        	<ul class="content_detail">
				<li>
					<img v-bind:src="sendPay" alt="" class="oImg" v-if="this.$route.query.amount<0">
					<img v-bind:src="resivePay" alt="" class="oImg" v-else>
					<!-- <span class="currency_name">{{this.$route.query.transfer_status==-1?$t("失败"):(this.$route.query.transfer_status==0?$t("等待处理"):(this.$route.query.transfer_status==1?$t("转账成功"):(this.$route.query.transfer_status==2?$t("转账中"):'')))}}</span> -->
					<span class="currency_name">{{ this.$route.query.transfer_status_msg }}</span>
					<div class="amount_of wx_rt">
						<p class="count wx_fontSize3">{{this.$route.query.amount | numFilter}}{{this.$route.query.title}}</p>
						<p class="money wx_fontSize2">{{this.$store.state.currency_char}}{{this.$route.query.fee}}</p>
					</div>
				</li>
			</ul>
			<div class="Qr_code">
				<span class="currency_name" style="top:15px;">
					<span class="receive wx_fontSize2" style="width:100px">{{$t('交易ID')}}:</span>
					<span class="form wx_fontSize1">
						<span style="width:80%;display: inline-block;" class="wx_one_ellipsis">{{Code}}</span>
						<img src="../../assets/img/index/ico_fuzhi_bzxq_hui.png" alt="" @click="copy($event,Code)">
					</span>
				</span>
				<div class="contact">
					<div ref="qrCodeUrl" id="qrcode"></div>
				</div>
			</div>
			<span class="title wx_fontSize2">{{$t('来自')}}:</span>
			<div class="title_main">
				<p class="wx_fontSize2 wx_two_ellipsis">{{this.$route.query.from_address}}</p>
				<img src="../../assets/img/coinDetail/ixo_sanjiao.png" alt="" class="zuobiao">
			</div>
			<!-- <p class="detail wx_fontSize2">查看更多</p> -->
			<img src="../../assets/img/coinDetail/ico_xiangxiajiantou.png" alt="" class="zhuanhuan">
			<span class="title wx_fontSize2">{{$t('发送到')}}:</span>
			<div class="title_main" style="margin-bottom: 20px;">
				<p class="wx_fontSize2 wx_two_ellipsis">{{this.$route.query.to_address}}</p>
				<img src="../../assets/img/coinDetail/ixo_sanjiao.png" alt="" class="zuobiao">
			</div>
			<!-- <p class="detail wx_fontSize2">查看更多</p> -->
			<span class="title wx_fontSize2">{{$t('备注')}}:</span>
			<div class="wx_fontSize2">{{memo}}</div>
        </div>
  	</div>
</template>

<script>
import { parseTime,sharejilu, httpAccountDepositNetworkList } from '@/utils/index'
import handleClipboard from "@/utils/clipboard";
import { Toast } from "mint-ui";
import QRCode from "qrcodejs2";
import { numFilter } from "@/filters/index";
export default {
	data(){
		return{
			amount:'',
			time:'',
			title:'',
			Code:'',
			memo:'',
			resivePay:require('@/assets/img/ico_huacru_caifu.png'),
		    sendPay:require('@/assets/img/ico_huachu_caifu.png'),
		}
	},
	mounted() {
    	var qrcode = new QRCode(this.$refs.qrCodeUrl, {
	      	text: this.Code,
	      	width: 40,
	      	height: 40,
	      	
	    });
	},
	activated(){
		this.title = this.$route.query.title;
		this.amount = this.$route.query.amount;
		this.time = this.$route.query.log_time;
		this.Code = this.$route.query.tx_id;
		if(this.$route.query.memo){
			this.memo = this.$route.query.memo
		}else{
			this.memo = '--'
		}
	},
	methods:{
        copy: function(event, val) {
	      	handleClipboard(
		        val,
		        event,
		        () => {
		          Toast(this.$t("fuzhicg"));
		        },
		        () => {
		          Toast(this.$t("fuzhicc"));
		        }
	      	);
	    },
	    doshare(){
	        var p={
	          time:this.time,
	          amount:this.amount,
	          title:this.title,
	          id:this.Code,
	          from_address:this.$route.query.from_address,
	          to_address:this.$route.query.to_address,
	          memo:this.memo,
	        }
	        console.log(p);
	        sharejilu(JSON.stringify(p));
	    }
	}
}
</script>

<style scoped>
#coinDetail{width:100%;height:100%;background:#f6f6f6;}
.add{width:20px;height:20px;}
.mint-header{background: #ffffff;color:#212529;border-bottom: 1px solid #e3e8ed;}
.mint-button--default{color:#656b79 !important;}
.content{padding:0 15px;padding-bottom: 40px}
.time{padding-top:50px;text-align: left;color:#8c92a8;}
.content_detail{position: relative;box-shadow:0 0 20px rgba(5,61,109,0.2);}
.content_detail li{width:100%;background:#fff;margin-top:12px;}
.oImg{width:48px;height:48px;margin:15px 14px 12px 14px;border:1px solid #dddddd;border-radius: 50%;}
.currency_name{position: relative;top:-30px;color:#212529;}
/*.currency_name{position: relative;display: inline-block;top:-40px;}*/
.receive{position: absolute;top:0;}
.form{position: relative;top:25px;color:#8c92a8;}
.form img{width:13px;height:13px;margin-left: 10px;}
.amount_of{width:40%;height:100%;text-align: right;padding:0 10px;}
.count{color:#212529;padding:15px 0 10px 0;font-weight: bold;}
.money{color:#8c92a8;}

.Qr_code{margin-top:12px;height:80px;position: relative;padding:0 15px;}
.contact{height:40px;height:40px;position: absolute;right:0px;bottom:20px;line-height: 30px;color:#212529;}
.title{margin:15px 0 0px 0;color:#212529;}
.title_main{box-shadow:0 0 20px rgba(5,61,109,0.2);border-radius: 5px;background: #fff;margin-top:10px;padding:20px 10px;position: relative;}
.title_main p{width:100%;}
.zuobiao{position: absolute;bottom: 0;right: 0;width:18px;height:18px;}
.zhuanhuan{width:19px;height: 19px;margin:18px calc(50% - 9.5px) 0 calc(50% - 9.5px);}
.detail{width:100%;color:#0191f5;text-align: right;margin-top:5px;}
.main{margin:10px 0;}
</style>
